// src/i18n/es/hmiSimulator.js
const hmiSimulator = {
    name: 'Simulador HMI',
    messages: {
        device_provisioned_successfully: 'Dispositivo provisionado con éxito',
    },
    panel: {
        title: 'Simulador HMI',
        subtitle: 'Herramienta de pruebas y desarrollo',
        device: 'Dispositivo',
        tablet: 'Tablet 7"',
        kiosk: 'Kiosk 10"',
        tablet_spec: '1024×600 · Horizontal',
        kiosk_spec: '800×1280 · Vertical',
        status: 'Estado',
        provisioned: 'Provisionado',
        not_provisioned: 'No provisionado',
        connection: 'Conexión',
        online: 'En línea',
        offline: 'Sin conexión',
        device_id: 'ID Dispositivo',
        screen: 'Pantalla',
        screen_provision: 'Provisioning',
        screen_main: 'Principal',
        screen_locker: 'Taquilla',
        screen_staff: 'Personal',
        screen_settings: 'Ajustes',
        hotel: 'Hotel',
        name: 'Nombre',
        brand_color: 'Color de marca',
        languages: 'Idiomas',
        operation_mode: 'Modo de operación',
        mode_pms_integrated: 'PMS INTEGRADO',
        mode_email_based: 'BASADO EN EMAIL',
        mode_tag_only: 'SOLO ETIQUETAS',
        guest_access_methods: 'Métodos de acceso',
        email_code: 'Código por email',
        qr_code: 'Código QR',
        rfid_card: 'Tarjeta RFID',
        manual_reservation: 'Reserva manual',
        pms_validation: 'Validación PMS',
        code_expiration: 'Expiración de código',
        code_length: 'Longitud de código',
        digits: 'dígitos',
        controllers: 'Controladores',
        locker_controllers: 'Controladores de taquillas',
        reset_device: 'Resetear dispositivo',
        reset_device_hint: 'Elimina la configuración y requiere re-provisioning',
        getting_started: 'Primeros pasos',
        getting_started_text: 'Introduce un código de provisioning en la pantalla del dispositivo para conectarlo a un hotel. El código se genera desde el panel de gestión de HMIs.',
        footer: 'Locker Manager · Simulador HMI v1.0',
    },
    api_monitor: {
        title: 'API Monitor',
        all: 'Todos',
        errors: 'Errores',
        clear: 'Limpiar',
        no_requests: 'Sin peticiones API todavía',
    },
};

export default hmiSimulator;
